// extracted by mini-css-extract-plugin
export default {"title":"ProfileEdit_title__zbe21","area":"ProfileEdit_area__EFud4","container":"ProfileEdit_container__9Y0Zh","select_menu":"ProfileEdit_select_menu__5aS20"};